// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var InvoiceNinja = require("../../../shared/src/bindings/InvoiceNinja.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var CommonTypes_User_Id = require("../../../shared/src/types/CommonTypes_User_Id.bs.js");
var StripeTypes_Customer = require("../../../shared/src/bindings/StripeTypes_Customer.bs.js");
var CommonTypes_Business_Id = require("../../../shared/src/types/business/CommonTypes_Business_Id.bs.js");

var Raw = {};

function parse(value) {
  var value$1 = value.invoiceNinjaContactKey;
  var value$2 = value.stripeCustomerId;
  var value$3 = value.user;
  return {
          businessName: value.businessName,
          enableRequestedWorkers: value.enableRequestedWorkers,
          id: CommonTypes_Business_Id.GraphQL_API.parse(value.id),
          invoiceNinjaContactKey: !(value$1 == null) ? value$1 : undefined,
          markupRate: value.markupRate,
          stripeCustomerId: !(value$2 == null) ? value$2 : undefined,
          tipsPaidByQwickMarkup: value.tipsPaidByQwickMarkup,
          user: !(value$3 == null) ? ({
                id: CommonTypes_User_Id.GraphQL_API.parse(value$3.id)
              }) : undefined
        };
}

function serialize(value) {
  var value$1 = value.user;
  var user;
  if (value$1 !== undefined) {
    var value$2 = value$1.id;
    var value$3 = Curry._1(CommonTypes_User_Id.GraphQL_API.serialize, value$2);
    user = {
      id: value$3
    };
  } else {
    user = null;
  }
  var value$4 = value.tipsPaidByQwickMarkup;
  var value$5 = value.stripeCustomerId;
  var stripeCustomerId = value$5 !== undefined ? value$5 : null;
  var value$6 = value.markupRate;
  var value$7 = value.invoiceNinjaContactKey;
  var invoiceNinjaContactKey = value$7 !== undefined ? value$7 : null;
  var value$8 = value.id;
  var value$9 = Curry._1(CommonTypes_Business_Id.GraphQL_API.serialize, value$8);
  var value$10 = value.enableRequestedWorkers;
  var value$11 = value.businessName;
  return {
          businessName: value$11,
          enableRequestedWorkers: value$10,
          id: value$9,
          invoiceNinjaContactKey: invoiceNinjaContactKey,
          markupRate: value$6,
          stripeCustomerId: stripeCustomerId,
          tipsPaidByQwickMarkup: value$4,
          user: user
        };
}

function verifyArgsAndParse(_WebTypes_Business, value) {
  return parse(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  var match = param.user;
  if (match !== undefined) {
    return Relude_Option.pure({
                businessName: param.businessName,
                businessOwnerUserId: match.id,
                enableRequestedWorkers: param.enableRequestedWorkers,
                id: param.id,
                invoiceNinjaContactKey: Curry._2(Relude_Option.flatMap, InvoiceNinja.ContactKey.fromString, param.invoiceNinjaContactKey),
                markupRate: param.markupRate,
                stripeCustomerId: Curry._2(Relude_Option.flatMap, StripeTypes_Customer.Id.fromString, param.stripeCustomerId),
                tipsPaidByQwickMarkup: param.tipsPaidByQwickMarkup
              });
  }
  
}

var query = "fragment WebTypes_Business on Business   {\nbusinessName  \nenableRequestedWorkers  \nid  \ninvoiceNinjaContactKey  \nmarkupRate  \nstripeCustomerId  \ntipsPaidByQwickMarkup  \nuser  {\nid  \n}\n\n}\n";

exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
/* InvoiceNinja Not a pure module */
